import { useState, useMemo, useCallback } from "react";
import { CELL_PADDING } from "components/common/EntityDataTable/Constants";
const useHeaderMinWidths = () => {
  const [headerSectionsWidth, setHeaderSectionsWidth] = useState({});
  const headerMinWidths = useMemo(
    () => Object.fromEntries(
      Object.entries(headerSectionsWidth).map(([colId, { left = 0, right = 0 }]) => [
        colId,
        Math.round(left + right) + CELL_PADDING * 2
      ])
    ),
    [headerSectionsWidth]
  );
  const handleHeaderSectionResize = useCallback((colId, part, width) => {
    setHeaderSectionsWidth((cur) => {
      var _a;
      const currentCol = (_a = cur[colId]) != null ? _a : {};
      const roundedWidth = Math.round(width);
      if (currentCol[part] === roundedWidth) {
        return cur;
      }
      return { ...cur, [colId]: { ...currentCol, [part]: roundedWidth } };
    });
  }, []);
  return { headerMinWidths, handleHeaderSectionResize };
};
export default useHeaderMinWidths;
